import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=5f61b533&"
import script from "./Share.vue?vue&type=script&lang=ts&"
export * from "./Share.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports